import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {StoreModule} from '@ngrx/store';
import {reducers} from './veranstaltung-home.reducer';
import {MarkdownModule} from 'ngx-markdown';
import {TranslateModule} from '@ngx-translate/core';
import {VeranstaltungHomePage} from './veranstaltung-home.page';
import {PipesModule} from '../../../../sopi/pipes/pipes.module';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';

const routes: Routes = [
    {
        path: '',
        component: VeranstaltungHomePage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        MarkdownModule.forChild(),
        StoreModule.forFeature('VeranstaltungHomePage', reducers),
        TranslateModule,
        SopiComponentsModule
    ],
    declarations: [VeranstaltungHomePage],
    exports: [
        VeranstaltungHomePage
    ]
})
export class VeranstaltungHomePageModule {
}
